import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { apiVerifyEmail } from '../utils/api';

function getTokenFromUrl() {
  return new URLSearchParams(window.location.search).get('token') || '';
}

// Dedicated landing page for the verify-email link — deliberately not just a
// redirect straight to the Vault, so the confirmation (and what it unlocked)
// actually gets seen before moving on.
export default function EmailVerifyPage({ onDone }) {
  const { t } = useTranslation('verify');
  const { user, refreshUser } = useAuth();
  const [token] = useState(getTokenFromUrl);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [result, setResult]   = useState(null);

  useEffect(() => {
    if (!token) { setError(t('error_missing_token')); setLoading(false); return; }
    apiVerifyEmail(token)
      .then(data => {
        setResult(data);
        // If this browser is signed in as the account that owns the link,
        // reflect the confirmed state immediately instead of waiting for
        // the next /auth/me refresh.
        if (user && refreshUser) refreshUser({ ...user, emailVerified: true });
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]); // eslint-disable-line

  return (
    <div className="auth-page">
      <div className="cloud-layer" aria-hidden="true"><div className="cloud c1"/><div className="cloud c2"/><div className="cloud c4"/><div className="cloud c6"/><div className="cloud c9"/></div>
      <div className="auth-card">
        {loading && (
          <div className="auth-logo">
            <span className="logo-icon">✉️</span>
            <h1>{t('verify_pending')}</h1>
          </div>
        )}

        {!loading && result && (
          <>
            <div className="auth-logo">
              <span className="logo-icon">✅</span>
              <h1>{t('verify_success_title')}</h1>
              <p className="auth-tagline">
                {result.alreadyVerified ? t('verify_already_confirmed') : t('verify_rewards_unlocked')}
              </p>
            </div>
            <button className="btn-primary" onClick={onDone}>{t('btn_go_to_vault')}</button>
          </>
        )}

        {!loading && error && (
          <>
            <div className="auth-logo">
              <span className="logo-icon">⚠️</span>
              <h1>{t('verify_error_title')}</h1>
            </div>
            <div className="auth-error">⚠ {error}</div>
            <button className="btn-primary" onClick={onDone}>{t('btn_back_to_home')}</button>
          </>
        )}
      </div>
    </div>
  );
}
